module.exports = __webpack_public_path__ + "static/images/components/WGCWXConfirmation/images/alert.cf2e803a.png";


//////////////////
// WEBPACK FOOTER
// ./components/WGCWXConfirmation/images/alert.png
// module id = 2729
// module chunks = 11